export const getMeetingTypeFromURL = meetingUrl => {
  let meeting_type = 'unknown';
  if (meetingUrl.includes('zoom.us')) meeting_type = 'zoom';
  if (meetingUrl.startsWith('https://meet.google.com')) meeting_type = 'hangouts';
  if (meetingUrl.startsWith('https://www.uberconference.com')) meeting_type = 'dialpad';
  if (meetingUrl.startsWith('https://meetings.dialpad.com')) meeting_type = 'dialpad';
  if (meetingUrl.startsWith('https://join.skype.com')) meeting_type = 'skype';
  if (meetingUrl.startsWith('https://teams.microsoft.com')) meeting_type = 'teams';
  if (meetingUrl.includes('gotomeeting.com') || meetingUrl.includes('gotomeet.me')) meeting_type = 'goto_meeting';

  return meeting_type;
};

export const getHumanizedMeetingTypeFromURL = meetingUrl => {
  const meeting_type_to_humanized_meeting_type = {
    unknown: 'Web Conference',
    goto_meeting: 'GoToMeeting',
  };
  const meeting_type = getMeetingTypeFromURL(meetingUrl);
  const meeting_type_capitalized_with_meeting = `${
    meeting_type.charAt(0).toUpperCase() + meeting_type.slice(1)
  } Meeting`;
  return meeting_type_to_humanized_meeting_type[meeting_type] || meeting_type_capitalized_with_meeting;
};
